import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { AppMemo } from '../app';
import { UserNotificationProvider } from '../components/userNotification/userNotificationProvider';
import { UserNotification } from '../components/userNotification/userNotifications';

export function ReduxStateProvider() {
  // TODO: move notifications out of this component
  return (
    <Provider store={store}>
      <UserNotificationProvider>
        <AppMemo />
        <UserNotification />
      </UserNotificationProvider>
    </Provider>
  );
}
